<template>
  <span class="content-modal-footer">
    <span @click="changeStep(1)" class="circle" v-bind:class="{ filled: selected && selected === 1 }" />
    <span @click="changeStep(2)" class="circle" v-bind:class="{ filled: selected && selected === 2 }" />
    <span @click="changeStep(3)" class="circle" v-bind:class="{ filled: selected && selected === 3 }" />
    <span @click="changeStep(4)" class="circle" v-bind:class="{ filled: selected && selected === 4 }" />
  </span>
</template>

<script>
export default {
  name: 'ModalStepFooter',
  props: ['selected'],
  methods: {
    changeStep(stepNumber) {
      this.$emit('stepChanged', stepNumber);
    },
  },
};
</script>

<style scoped>
.circle {
  display: block;
  width: 15px;
  height: 15px;
  margin: 0 5px;
  border-radius: 15px;
  border: solid 1px #0088ec;
  cursor: pointer;
}
.content-modal-footer {
  display: flex;
  align-items: center;
  justify-content: center;
}

.filled {
  background: #0088ec;
}
</style>
